<c-container class="mt-5">
  <h2>Notification Preferences</h2>

  @if (isCrossGame) {
    <app-choose-your-game [message]="'Select a game to view your preferences'"
                          (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>
  }

  @if (game) {
    @if (uiState != uiStateForTemplate.ShowLoading) {
      <p class="text-muted" data-testid="notification-preferences-intro">
        Tick the emails you want for this game. They go to your sign-in email address.
      </p>
      <mat-selection-list (selectionChange)="onSelectionChange($event)"
                          data-testid="notification-preferences-list">
        @for (notificationType of potentialNotificationTypes; track notificationType) {
          <mat-list-option [value]="notificationType.Value"
                           [selected]="isNotificationTypeSelected(notificationType.Value)"
                           [lines]="3"
                           data-testid="notification-preferences-options">
            <span matListItemTitle>{{ notificationType.Name }}</span>
            <span matListItemLine data-testid="notification-preferences-description">{{ descriptionFor(notificationType.Value) }}</span>
          </mat-list-option>
        }
      </mat-selection-list>
    }

    <button mat-raised-button color="primary"
            [disabled]="uiState == uiStateForTemplate.ShowRequestProcessing"
            (click)="saveMyPreferences()"
            data-testid="notification-preferences-save-button">
      @if (uiState == uiStateForTemplate.ShowRequestProcessing) {
        <mat-spinner diameter="32" color="accent"></mat-spinner>
      } @else {
        Save my Notification Preferences
      }
    </button>
  }

</c-container>

